import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const HeaderWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'baseline'
})
